module.exports = __webpack_public_path__ + "img/20201019140707601.08dfd9a3.jpg";